import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SnackBarWithIconComponent} from "../components/snackbar-with-icon/snackbar-with-icon.component";

@Injectable({providedIn: 'root'})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {
  }

  showSuccess(message: string) {
    this.snackBar.openFromComponent(SnackBarWithIconComponent, {
      data: {
        message: message,
        icon: 'check_circle'
      },
      duration: 50000,
      panelClass: ['success-snackbar', 'above-footer'],
      verticalPosition: 'bottom',
    });
  }

}
